import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { selectCurrentLanguage } from '@shared/api/reduxToolkit';
import { detectBrowserLanguage } from '@shared/config/i18n';
import { useActions } from '@shared/lib/hooks';

import { useAccountLanguage } from './useAccountLanguage';

export const LanguageInitializer = ({ children }) => {
	const { setLanguage } = useActions();
	const { i18n } = useTranslation();
	const currentLanguage = useSelector(selectCurrentLanguage);
	const isRehydrated = useSelector((state) => state.language?._persist?.rehydrated);

	useEffect(() => {
		if (!isRehydrated) return;

		const lang = currentLanguage ?? detectBrowserLanguage();

		if (currentLanguage !== lang) {
			setLanguage(lang);
		}

		if (i18n.resolvedLanguage !== lang) {
			i18n.changeLanguage(lang);
		}
	}, [currentLanguage, i18n, isRehydrated, setLanguage]);

	useAccountLanguage({ isRehydrated });

	return children;
};
